import './fonts/font.css';

import { black } from './colors';
import idsTokensDefault from './utils/tokens/idsTokens';

export const fontFamily = idsTokensDefault.typography.font.fallback;

export const getFontFamily = (idsTokens = idsTokensDefault) => {
  return idsTokens.typography.font.fallback;
};

/**
 * Font smoothing properties for better text rendering across browsers.
 * Use this constant to ensure consistent font rendering throughout the application.
 *
 * @example
 * // In a component's styles
 * const styles = {
 *   ...fontSmoothing,
 *   fontSize: '16px',
 * };
 */
export const fontSmoothing = {
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  fontSmooth: 'never',
};

export default (idsTokens = idsTokensDefault) => ({
  fontFamily: getFontFamily(idsTokens),
  ...fontSmoothing,
  // headline
  h1: {
    color: black,
    fontSize: idsTokens.typography.font.size['7x'],
    fontWeight: idsTokens.typography.font.weight.regular,
    lineHeight: idsTokens.typography.lineHeight['6x'],
    letterSpacing: idsTokens.typography.spacing.letter.negative.lg,
  },
  // subheadline
  h2: {
    color: black,
    fontSize: idsTokens.typography.font.size['4x'],
    fontWeight: idsTokens.typography.font.weight.regular,
    lineHeight: idsTokens.typography.lineHeight['2x'],
    letterSpacing: idsTokens.typography.spacing.letter.none,
  },
  // title
  h3: {
    color: black,
    fontSize: idsTokens.typography.font.size['2x'],
    fontWeight: idsTokens.typography.font.weight.regular,
    lineHeight: idsTokens.typography.lineHeight['3x'],
    letterSpacing: idsTokens.typography.spacing.letter['2x'],
  },
  // subtitle
  h4: {
    color: black,
    fontSize: idsTokens.typography.font.size.xl,
    lineHeight: idsTokens.typography.lineHeight.xl,
    fontWeight: idsTokens.typography.font.weight.regular,
    letterSpacing: idsTokens.typography.spacing.letter.xl,
  },
  // bodyDefault
  body1: {
    color: black,
    fontSize: idsTokens.typography.font.size.base,
    lineHeight: idsTokens.typography.lineHeight.base,
    fontWeight: idsTokens.typography.font.weight.regular,
    letterSpacing: idsTokens.typography.spacing.letter.lg,
  },
  // bodySmall
  body2: {
    color: black,
    fontSize: idsTokens.typography.font.size.sm,
    lineHeight: idsTokens.typography.lineHeight.sm,
    fontWeight: idsTokens.typography.font.weight.regular,
    letterSpacing: idsTokens.typography.spacing.letter.md,
  },
  caption: {
    color: black,
    fontSize: idsTokens.typography.font.size.xs,
    lineHeight: idsTokens.typography.lineHeight.xs,
    fontWeight: idsTokens.typography.font.weight.regular,
    letterSpacing: idsTokens.typography.spacing.letter.sm,
  },
  button: {
    textTransform: 'none',
  },
});
